/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Packs_PopularInputs */

const en_directory_ai_tools_packs_popular = /** @type {(inputs: Directory_Ai_Tools_Packs_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most popular`)
};

const zh_directory_ai_tools_packs_popular = /** @type {(inputs: Directory_Ai_Tools_Packs_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最受欢迎`)
};

/**
* | output |
* | --- |
* | "Most popular" |
*
* @param {Directory_Ai_Tools_Packs_PopularInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_packs_popular = /** @type {((inputs?: Directory_Ai_Tools_Packs_PopularInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Packs_PopularInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_packs_popular(inputs)
	return zh_directory_ai_tools_packs_popular(inputs)
});
export { directory_ai_tools_packs_popular as "directory.ai_tools.packs.popular" }